import React from "react";
import Header from "../../components/Header/Header";
import AllProducts from "../../sections/AllProducts/AllProducts";
import "./Discover.css";

function Discover() {
  return (
    <main className="Discover">
      <Header
        title="Discover Our Collection"
        subtitle="Explore Thousands of Books Across All Genres"
        actionBtn="Start Browsing"
      />
      <AllProducts />
    </main>
  );
}

export default Discover;
